"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.securityEpics = exports.updateRevenueImpactDashboardCreatedPipelineEpic = exports.updateRevenueImpactDashboardAccessEpic = exports.updateDashboardAccessEpic = exports.updateDomainsEpic = exports.securitySettingsLoadEpic = exports.toggleForceSsoEpic = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _services = require("@alycecom/services");

var _security = require("./security.actions");

var _security2 = require("./security.selectors");

var toggleForceSsoEpic = function toggleForceSsoEpic(action$, state$, _ref) {
  var apiService = _ref.apiService,
      showGlobalMessage = _ref.messagesService.showGlobalMessage;
  return action$.pipe((0, _utils.ofType)(_security.toggleForceSsoRequest), (0, _operators.withLatestFrom)(state$), (0, _operators.mergeMap)(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        state = _ref3[1];

    var enabled = (0, _security2.getForceSso)(state);
    return apiService.put('/api/v1/security/settings/force-sso', {
      body: {
        enabled
      }
    }, true).pipe((0, _operators.mergeMap)(function (_ref4) {
      var data = _ref4.data;
      return [(0, _security.toggleForceSsoSuccess)(data.enabled), showGlobalMessage({
        type: 'success',
        text: "Force SSO has been successfully ".concat(data.enabled ? 'enabled' : 'disabled')
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_security.toggleForceSsoFail))), (0, _operators.takeUntil)(action$.ofType(_security.toggleForceSsoRequest)));
  }));
};

exports.toggleForceSsoEpic = toggleForceSsoEpic;

var securitySettingsLoadEpic = function securitySettingsLoadEpic(action$, state$, _ref5) {
  var apiService = _ref5.apiService;
  return action$.pipe((0, _utils.ofType)(_security.securityLoadRequest), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function () {
    return apiService.get('/api/v1/security/settings', undefined, true).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _security.securityLoadSuccess)(response)];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_security.securityLoadFail))));
  }));
};

exports.securitySettingsLoadEpic = securitySettingsLoadEpic;

var updateDomainsEpic = function updateDomainsEpic(action$, state$, _ref6) {
  var apiService = _ref6.apiService,
      showGlobalMessage = _ref6.messagesService.showGlobalMessage;
  return action$.pipe((0, _utils.ofType)(_security.updateDomainsRequest), (0, _operators.mergeMap)(function (action) {
    return apiService.put('/api/v1/security/settings/allowed-domains', {
      body: {
        allowedDomains: action.payload
      }
    }, true).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _security.updateDomainsSuccess)(response.data.allowedDomains), showGlobalMessage({
        type: 'success',
        text: 'Domain restrictions have been successfully updated'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_security.updateDomainsFail))), (0, _operators.takeUntil)(action$.ofType(_security.updateDomainsRequest)));
  }));
};

exports.updateDomainsEpic = updateDomainsEpic;

var updateDashboardAccessEpic = function updateDashboardAccessEpic(action$, state$, _ref7) {
  var apiService = _ref7.apiService,
      showGlobalMessage = _ref7.messagesService.showGlobalMessage;
  return action$.pipe((0, _utils.ofType)(_security.updateDashboardAccess.pending), (0, _operators.switchMap)(function (_ref8) {
    var payload = _ref8.payload;
    return apiService.put('/api/v1/security/settings/dashboard-access', {
      body: {
        enabled: payload.enabled
      }
    }, true).pipe((0, _operators.mergeMap)(function (_ref9) {
      var data = _ref9.data;
      return [_security.updateDashboardAccess.fulfilled(data), showGlobalMessage({
        type: _services.MessageType.Success,
        text: 'Alyce Website Access has been successfully updated'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_security.updateDashboardAccess.rejected()))));
  }));
};

exports.updateDashboardAccessEpic = updateDashboardAccessEpic;

var updateRevenueImpactDashboardAccessEpic = function updateRevenueImpactDashboardAccessEpic(action$, state$, _ref10) {
  var apiService = _ref10.apiService,
      showGlobalMessage = _ref10.messagesService.showGlobalMessage;
  return action$.pipe((0, _utils.ofType)(_security.updateRevenueImpactDashboardAccess.pending), (0, _operators.switchMap)(function (_ref11) {
    var payload = _ref11.payload;
    return apiService.put('/api/v1/security/settings/revenue-impact-dashboard-access', {
      body: {
        enabled: payload.enabled
      }
    }, true).pipe((0, _operators.mergeMap)(function (_ref12) {
      var data = _ref12.data;
      return [_security.updateRevenueImpactDashboardAccess.fulfilled(data), showGlobalMessage({
        type: _services.MessageType.Success,
        text: 'Revenue Impact Dashboard Access has been successfully updated'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_security.updateRevenueImpactDashboardAccess.rejected()))));
  }));
};

exports.updateRevenueImpactDashboardAccessEpic = updateRevenueImpactDashboardAccessEpic;

var updateRevenueImpactDashboardCreatedPipelineEpic = function updateRevenueImpactDashboardCreatedPipelineEpic(action$, state$, _ref13) {
  var apiService = _ref13.apiService,
      showGlobalMessage = _ref13.messagesService.showGlobalMessage;
  return action$.pipe((0, _utils.ofType)(_security.updateRevenueImpactDashboardCreatedPipeline.pending), (0, _operators.switchMap)(function (_ref14) {
    var payload = _ref14.payload;
    return apiService.put('/api/v1/security/settings/revenue-impact-dashboard-created-pipeline', {
      body: {
        enabled: payload.enabled,
        numberOfDaysBeforeOpportunityIsCreated: payload.numberOfDaysBeforeOpportunityIsCreated
      }
    }, true).pipe((0, _operators.mergeMap)(function (_ref15) {
      var data = _ref15.data;
      return [_security.updateRevenueImpactDashboardCreatedPipeline.fulfilled(data), showGlobalMessage({
        type: _services.MessageType.Success,
        text: 'Alyce-Created Pipeline has been successfully updated'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_security.updateRevenueImpactDashboardCreatedPipeline.rejected()))));
  }));
};

exports.updateRevenueImpactDashboardCreatedPipelineEpic = updateRevenueImpactDashboardCreatedPipelineEpic;
var securityEpics = [toggleForceSsoEpic, securitySettingsLoadEpic, updateDomainsEpic, updateDashboardAccessEpic, updateRevenueImpactDashboardAccessEpic, updateRevenueImpactDashboardCreatedPipelineEpic];
exports.securityEpics = securityEpics;